//Packages
import React, { Component } from 'react';
//import {GoogleLogin, GoogleLogout} from 'react-google-login';

//Components 
import Banner from './components/banner.js';
import logo from './logo.png';


function AboutScreen(){
    document.title = "Schedule Bot";

    // Handles a successfull login from the google account service
    const loginSuccess = (res) => {
      //console.log('login success from:' , res.profileObj)

      //Update local storage to have google id and google name
      var profile = res.profileObj;
      localStorage.setItem('Name', profile.name);
      localStorage.setItem('ID', res.googleId);

      //Reload the page to move to the next page if 
      //the login actually worked. Could also forcefully redirect 
      window.location.reload(false);
     }
  
     // Handles a failed login from the google account service by console logging 
    const loginFailure = (res) => {
      console.log('login failure:' , res)
    }
      return (
        
        <div className="about"> 
        <Banner></Banner>
        <div id="page_alignment" className="container">
        <div id="aboutDiv">
          
        <h2>Thank you for using Schedule Bot</h2>
        
        <p>This project came about because I was having a hard time getting my friends in college to plan a beach hangout. And I wanted this exact service.
          Schedule-bot does not sell your data, we retain as little of your information as possible. 
           </p>
        <p>For questions and inquiries please contact me here: <a href="mailto:schedule.solver@gmail.com">&#128231;</a></p>
        <p>Please enjoy letting the bot help find the perfect time for everyone’s schedule.</p>
        </div>
        </div>
        </div>
      );
}

export default AboutScreen;